import React from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiRepeat, FiGrid, FiUser, FiLifeBuoy } from 'react-icons/fi';
import { tapScale, tapScaleTransition } from '../helpers/animations';
import { tokenPath } from '../helpers';

function matchesPath(pathname, basePath) {
  return pathname === basePath || pathname.startsWith(`${basePath}/`);
}

function BottomNav() {
  const { token } = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  const homePath = tokenPath(token);
  const tradePath = tokenPath(token, 'trade');
  const buyPath = tokenPath(token, 'buy');
  const sellPath = tokenPath(token, 'sell');
  const supportPath = tokenPath(token, 'support');
  const accountPath = tokenPath(token, 'account');
  const bankAccountsPath = tokenPath(token, 'bank-accounts');
  const buyReportPath = tokenPath(token, 'buy-report');
  const sellReportPath = tokenPath(token, 'sell-report');

  const navItems = [
    { to: homePath, icon: FiGrid, label: 'Home', match: 'home' },
    { to: tradePath, icon: FiRepeat, label: 'Trade', match: 'trade' },
    { to: supportPath, icon: FiLifeBuoy, label: 'Help', match: 'support' },
    { to: accountPath, icon: FiUser, label: 'Me', match: 'account' },
  ];

  return (
    <motion.nav
      className="app-shell-nav"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.25, 0.46, 0.45, 0.94] }}
    >
      {navItems.map(({ to, icon: Icon, label, match }) => (
        <NavLink
          key={match}
          to={to}
          end={match === 'home'}
          className={({ isActive }) => {
            const tradeSection =
              match === 'trade' &&
              (matchesPath(pathname, tradePath) ||
                matchesPath(pathname, buyPath) ||
                matchesPath(pathname, sellPath));
            const accountSection =
              match === 'account' &&
              (matchesPath(pathname, accountPath) ||
                matchesPath(pathname, bankAccountsPath) ||
                matchesPath(pathname, buyReportPath) ||
                matchesPath(pathname, sellReportPath));
            return `nav-item${isActive || tradeSection || accountSection ? ' active' : ''}`;
          }}
        >
          <motion.span
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
            whileTap={tapScale}
            transition={tapScaleTransition}
          >
            <Icon size={16} />
            <span>{label}</span>
          </motion.span>
        </NavLink>
      ))}
    </motion.nav>
  );
}

export default BottomNav;
